import { render, staticRenderFns } from "./TravellerItem.vue?vue&type=template&id=08a6d06a&scoped=true&"
import script from "./TravellerItem.vue?vue&type=script&lang=js&"
export * from "./TravellerItem.vue?vue&type=script&lang=js&"
import style0 from "./TravellerItem.vue?vue&type=style&index=0&id=08a6d06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6d06a",
  null
  
)

export default component.exports